// Uyarı bandı — onay panelinin EN ÜSTÜNDE (spec §6.3).
//
// Kaynak İKİ yerden gelir:
//   1) Backend GET /api/vehicles/loads/{id} → warnings[] {code, message, severity}
//      (limit aşımı · kapasite aşımı · revize · ürün kartıyla eşleşmeyen kalem)
//   2) İstemci tarafı: geçmiş ortalamadan sapma (Plasiyer 360'taki son 4 yüklemeden hesaplanır —
//      backend bu karşılaştırmayı yapmıyor, veri panelde zaten var).
import './vehicleLoad.css';

/**
 * @param {Array<{code:string,message:string,severity:string}>} warnings  backend uyarıları
 * @param {Array<string>} extra  istemci tarafı ek uyarı metinleri
 */
export function WarningBand({ warnings = [], extra = [] }) {
  const messages = [
    ...warnings.map((w) => ({ text: w.message || w.code, severity: w.severity || 'warning' })),
    ...extra.filter(Boolean).map((text) => ({ text, severity: 'warning' })),
  ];
  if (messages.length === 0) return null;

  // Tümü "info" ise band sarı (bilgilendirme), en az bir uyarı varsa kırmızı.
  const onlyInfo = messages.every((m) => m.severity === 'info');

  return (
    <div className={`vl-band${onlyInfo ? ' vl-band--info' : ''}`} role="alert">
      <span aria-hidden="true" style={{ fontSize: 15, lineHeight: 1.2 }}>⚠</span>
      <div>
        <strong>{messages.length} uyarı</strong>
        <ul>
          {messages.map((m, i) => <li key={`${m.text}-${i}`}>{m.text}</li>)}
        </ul>
      </div>
    </div>
  );
}

export default WarningBand;
